import React from "react";
import { Text, TouchableOpacity } from "react-native";

import ElementItem from "../../elements/list/ElementItem";
import Icons from "../../common/icons/index";
import integrationStyles from "./integrationStyles";

export default function IntegrationRuleElement({
  data = {},
  controller,
  onPress = () => {},
}) {
  const integrationElement = data.element;

  return (
    <>
      {integrationElement ? (
        <ElementItem
          item={integrationElement}
          controller={controller}
          noIcons={true}
          hideActions={true}
          disabledHighlight={true}
          onElementSelected={() => onPress(data)}
          style={{
            borderWidth: 0,
            paddingLeft: 0,
          }}
        />
      ) : (
        <TouchableOpacity
          style={integrationStyles.placeholder}
          onPress={() => onPress(data)}
        >
          <Icons.AddIcon
            width={20}
            height={20}
            color="#ABADB3"
            style={{
              marginRight: 8,
              marginLeft: 16,
            }}
          />
          <Text style={integrationStyles.placeholderText}>
            Add associated Element
          </Text>
        </TouchableOpacity>
      )}
    </>
  );
}
